import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Icon from "@mui/material/Icon"
import TextField from "@mui/material/TextField"
import { useState } from "preact/hooks"
import { v4 as uuid } from "uuid"
import type { Item } from "./EditableList"
import { parseCandidateList } from "./poll"

interface Props {
  onImport: (items: Item[]) => void
  disabled?: boolean
}

export function ImportCandidatesButton({ onImport, disabled }: Props) {
  const [open, setOpen] = useState(false)
  const [text, setText] = useState("")

  const handleImport = () => {
    const lines = parseCandidateList(text)
    if (lines.length === 0) return
    onImport(lines.map((content) => ({ id: uuid(), content })))
    setText("")
    setOpen(false)
  }

  return (
    <>
      <Button
        size="small"
        startIcon={<Icon>upload</Icon>}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Import
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Import candidates</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            multiline
            fullWidth
            minRows={6}
            placeholder={"nachos\npizza\ntacos"}
            helperText="One option per line. Duplicates and blank lines are ignored."
            value={text}
            onChange={(e: any) => setText(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={parseCandidateList(text).length === 0}
            onClick={handleImport}
          >
            Add {parseCandidateList(text).length || ""} options
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
